"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ = require("../..");
var _Permissions = require("../../constants/Permissions");
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper");
var _SourcePropType = _interopRequireDefault(require("../SourcePropType"));
var _Permission = _interopRequireDefault(require("../Permissions/Permission"));
var _SourceListItemSettingsMenu = _interopRequireDefault(require("./SourceListItemSettingsMenu"));
var _2 = require("./..");
var _SourceTypeIcon = _interopRequireDefault(require("../SourceTypeIcon/SourceTypeIcon"));
var _SourceListItemHeader = require("./SourceListItemHeader.styled");
var _broadcastSourceHelper2 = require("../../utils/broadcastSourceHelper/broadcastSourceHelper");
var _ActiveSpeakerComponent = require("../ActiveSpeakerComponent");
var _constants = require("@studio/constants");
var _reactRedux = require("react-redux");
var _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// const definitions
var getViewPermissions = function getViewPermissions() {
  return [_Permissions.TOGGLE_SOURCE];
};
var ActiveSpeakerIndicatorWrapper = function ActiveSpeakerIndicatorWrapper(_ref) {
  var attendeeId = _ref.attendeeId,
    muted = _ref.muted,
    isStaged = _ref.isStaged,
    live = _ref.live;
  var isAttendeeTalking = (0, _reactRedux.useSelector)(function (state) {
    var _state$attendeeVoiceI;
    var voiceIntensity = ((_state$attendeeVoiceI = state.attendeeVoiceIntensity) === null || _state$attendeeVoiceI === void 0 ? void 0 : _state$attendeeVoiceI[attendeeId]) || 0;
    return voiceIntensity > _constants.ACTIVE_SPEAKER_INTENSITY_THRESHOLD;
  });
  var shouldDisplayActiveSpeakerIndicator = !muted && isAttendeeTalking;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_ActiveSpeakerComponent.ActiveSpeakerIndicator, {
    color: isStaged && !live ? _ActiveSpeakerComponent.IndicatorColor.GREEN : _ActiveSpeakerComponent.IndicatorColor.WHITE,
    display: shouldDisplayActiveSpeakerIndicator
  }));
};

/**
 * Component representing the header of a source list item.
 *
 * @param {Object} props - The properties object.
 * @param {Object} props.source - The source object.
 * @param {Function} props.onSourceDeleted - Callback function when the source is deleted.
 * @param {Function} props.onSourceEdited - Callback function when the source is edited.
 * @param {Boolean} props.live - Indicates if the source is live (on stage).
 * @param {Boolean} props.hover - Indicates if the source is being hovered over.
 * @param {Boolean} props.isStaged - Indicates if the source is selected (staged).
 * @param {Function} props.onSetSourceUnassigned - Callback function to unassign the source.
 * @param {Array} props.viewPermissions - Array of view permissions for the user.
 * @param {Object} props.user - The user object.
 * @param {Boolean} props.isDirectorSource - Indicates if the source is a director source.
 * @param {Function} props.onAssignSpeakers - Callback function to assign speakers.
 * @param {Function} props.onReplaceSlides - Callback function to replace slides.
 * @param {Function} props.onGoToPresentationPage - Callback function to navigate to the presentation page.
 *
 * @returns {JSX.Element} The rendered component.
 */
var SourceListItemHeader = function SourceListItemHeader(_ref2) {
  var source = _ref2.source,
    onSourceDeleted = _ref2.onSourceDeleted,
    onSourceEdited = _ref2.onSourceEdited,
    live = _ref2.live,
    hover = _ref2.hover,
    isStaged = _ref2.isStaged,
    onSetSourceUnassigned = _ref2.onSetSourceUnassigned,
    viewPermissions = _ref2.viewPermissions,
    user = _ref2.user,
    isDirectorSource = _ref2.isDirectorSource,
    onAssignSpeakers = _ref2.onAssignSpeakers,
    onReplaceSlides = _ref2.onReplaceSlides,
    onGoToPresentationPage = _ref2.onGoToPresentationPage;
  var allowEditButtonClick = (0, _broadcastSourceHelper.isMediaSource)(source) || (0, _broadcastSourceHelper.isPresenterSource)(source);
  var isPresenter = (0, _broadcastSourceHelper2.isCameraPresenter)(source);
  /**
   * This function is called by the permission wrapper to determine
   * if the featured should actually be enabled on the UI, given
   * the current user role permissions.
   *
   * @param {Boolean} enableFeature - Flag determining whether feature should be enabled.
   */
  var displayComponent = function displayComponent(enableFeature) {
    return _react["default"].createElement(_react["default"].Fragment, null, enableFeature && _react["default"].createElement(_SourceListItemSettingsMenu["default"], {
      isStaged: isStaged,
      live: live,
      sourceId: source._id,
      enableFeature: enableFeature,
      onSourceEdited: allowEditButtonClick ? onSourceEdited : function () {},
      onSourceDeleted: onSourceDeleted,
      onSetSourceUnassigned: onSetSourceUnassigned,
      type: source.type,
      value: source.value,
      thumbnail: source.thumbnail,
      isInitializing: source.isInitializing,
      isDirectorSource: isDirectorSource,
      onAssignSpeakers: onAssignSpeakers,
      onReplaceSlides: onReplaceSlides,
      onGoToPresentationPage: onGoToPresentationPage
    }));
  };
  var renderSourceIcon = function renderSourceIcon(source) {
    if (source.type === _.CAMERA_PRESENTER) return null;
    return _react["default"].createElement(_SourceTypeIcon["default"], {
      source: source,
      isStaged: isStaged,
      live: live
    });
  };
  var title = source.title.replace('media/', '');
  source.title = title;
  if (title.search(/media placeholder/gi) !== -1) {
    title = title.replace(/media/gi, 'Content');
  }
  return _react["default"].createElement(_SourceListItemHeader.ListItemHeader, {
    isStaged: isStaged,
    live: live,
    hover: hover
  }, renderSourceIcon(source), _react["default"].createElement(_SourceListItemHeader.ListItemTitle, {
    className: (0, _broadcastSourceHelper.isPresenterSource)(source) ? 'dd-privacy-mask' : '',
    live: live,
    hover: hover,
    isPresenter: isPresenter
  }, _react["default"].createElement(_SourceListItemHeader.Title, {
    id: "title_".concat(source._id)
  }, title), _react["default"].createElement(_2.ToolTip, {
    className: (0, _broadcastSourceHelper.isPresenterSource)(source) ? 'dd-privacy-mask' : '',
    targetElement: "title_".concat(source._id),
    placement: 'top',
    message: title
  })), _react["default"].createElement(_SourceListItemHeader.ActionWrapper, null, _react["default"].createElement(ActiveSpeakerIndicatorWrapper, {
    attendeeId: source.value,
    muted: source.muted,
    isStaged: isStaged,
    live: live
  }), live && _react["default"].createElement(_SourceListItemHeader.LiveBadge, null, _react["default"].createElement(_SourceListItemHeader.BadgeText, null, 'On stage')), hover && _react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayComponent.bind(_this),
    viewPermissions: viewPermissions,
    user: user
  })));
};
SourceListItemHeader.propTypes = {
  user: _propTypes.object,
  live: _propTypes.bool.isRequired,
  source: _SourcePropType["default"],
  hover: _propTypes.bool.isRequired,
  isDirectorSource: _propTypes.bool,
  viewPermissions: _propTypes.object,
  isStaged: _propTypes.bool.isRequired,
  onSetSourceUnassigned: _propTypes.func,
  onSourceEdited: _propTypes.func.isRequired,
  onSourceDeleted: _propTypes.func.isRequired,
  onAssignSpeakers: _propTypes.func,
  onReplaceSlides: _propTypes.func,
  onGoToPresentationPage: _propTypes.func
};
var _default = exports["default"] = (0, _react.memo)(SourceListItemHeader);